import Component from '../abstracts/Component';
import GalleryManager from '../utils/GalleryManager';

export default class CarouselComponent extends Component {
  get SELECTORS() {
    return {
      arrowRight: '[data-carousel-arrow-right]',
      arrowLeft: '[data-carousel-arrow-left]',
      scroller: '[data-carousel-simplebar-wrapper]',
      scrollerBox: '[data-carousel-wrapper]',
      item: '[data-carousel-item]',
      itemsContainer: '[data-carousel-items]',
      titleContainer: '[data-carousel-title]',
    };
  }

  get COMPONENTNAME() {
    return 'CarouselComponent';
  }

  constructor(htmlEl) {
    super(htmlEl);
  }

  bindEvents() {
    // launch carousel on custom event
    let ctx = this;

    this.$on(this.$customEvents.LOAD_COMPONENT.simplebar, () => {
      ctx.galleryManager = new GalleryManager(
        ctx.SELECTORS,
        ctx.$component,
        ctx.moduleLoader
      );
    });
  }

  initGallery() {
    this.galleryManager = new GalleryManager(
      this.SELECTORS,
      this.$component,
      this.moduleLoader
    );
  }

  render() {
    super.render();
    window.addEventListener('load', () => {
      if (this.$component !== undefined) {
        this.galleryManager = new GalleryManager(
          this.SELECTORS,
          this.$component,
          this.moduleLoader
        );
      }
    });
    this.bindEvents();
  }
}
